import React, { useEffect } from 'react'
import { Box, Button, Typography,IconButton } from '@mui/material'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { BackArrowIcon } from '../../../icons'
import CourseDetailsForm from '../../../components/CourseDetails/CourseDetailsForm'
import { useSelector, useDispatch } from 'react-redux'
import { setFields, resetFields } from '../reducer/courseFormSlice'
import { fetchCourse } from '../../../api/courseApi'

const CourseDetails = ({ backUrl = '/course-listing-management' }) => {
  const fields = useSelector(state => state.courseForm.fields)
  const userAuth = useSelector(state=>state?.auth)
  const dispatch = useDispatch()
  const { courseId } = useParams()
  const location = useLocation();
  const navigate = useNavigate();
  const resolvedBackUrl = location.state?.backUrl || backUrl;
  const isReviewer = userAuth?.user?.roles.some(ele=>ele?.module==="reviewer" && ele?.allowed===1)


  const handleBack = (e) => {
    e.preventDefault();
    if (resolvedBackUrl === -1) {
      navigate(-1);
    } else if (typeof resolvedBackUrl === 'string') {
      navigate(resolvedBackUrl, { state: { backUrl: location?.pathname, activeTab: location?.state?.activeTab } });
    } else {
      navigate(-1);
    }
  };

  const loadCourse = async (id=courseId) => {
    try {
      const updatedFields = await fetchCourse(id, fields,isReviewer)
      if (updatedFields) {
        dispatch(setFields(updatedFields))
      }
    } catch (err) {
      console.error('Error fetching course:', err)
    }
  }

  useEffect(() => {
    if (courseId) {
      loadCourse()
    } else {
      dispatch(resetFields())
    }
  }, [courseId, dispatch])

  return (
    <Box sx={{ background: '#fff' }}>
      <div className="page-header" style={{ position: 'sticky', top: '4.5rem', zIndex: '9', padding: '10px 15px', borderBottom: '1px solid #E6E7E8', background: '#fff' }}>
        <div className="row align-items-center">
          <div className="col">
            <Typography sx={{ fontSize: '18px', fontWeight: '600', color: '#15243E', display: 'flex', alignItems: 'center', gap: 1 }}>
              <IconButton onClick={handleBack} size="small" aria-label="Back">
                <BackArrowIcon />
              </IconButton>
              Course CRM Entry Form
            </Typography>
          </div>
          <div className="col">
            <Box display="flex" gap={2} sx={{ justifyContent: 'end' }}>
              {/* <Button sx={{ border: '1px solid #15243E', padding: '4px 15px', color: '#15243E', background: '#fff', fontSize: '14px' }}>Preview</Button> */}
              {/* <Button sx={{ border: '1px solid #1075FF', padding: '4px 15px', color: '#1075FF', background: '#fff', fontSize: '14px' }}>Save Draft</Button> */}
              {/* <Button sx={{ background: '#0463EF', color: '#fff', padding: '4px 15px', fontSize: '14px' }}>Publish</Button> */}
            </Box>
          </div>
        </div>
      </div>

      <CourseDetailsForm
        fields={fields}
        setFields={updatedFields => dispatch(setFields(updatedFields))}
        fetchCourse={loadCourse}
        editMode={isReviewer}
      />
    </Box>
  )
}

export default CourseDetails
